// extracted by mini-css-extract-plugin
export var arrow = "customScrollable-module--arrow--8da93";
export var container = "customScrollable-module--container--a92a0";
export var hidden = "customScrollable-module--hidden--41946";
export var nextArrow = "customScrollable-module--nextArrow--45775";
export var onlyXS = "customScrollable-module--onlyXS--0cd93";
export var previousArrow = "customScrollable-module--previousArrow--52410";
export var scrollbarThumb = "customScrollable-module--scrollbarThumb--f7cbd";
export var scrollbarTrack = "customScrollable-module--scrollbarTrack--61654";
export var vertical = "customScrollable-module--vertical--a0718";